import { ClientResource } from '@shared/resources/client';
import { ClientType } from '@shared/types/client-type';

export function getClientName(client: ClientResource) {
  return client.type === ClientType.person
    ? `${client.last_name} ${client.first_name}`
    : client.name;
}
